// extracted by mini-css-extract-plugin
module.exports = {"modal_animation_duration":"200ms","fallbackButton":"onfido-sdk-ui-Button-fallbackButton"};